<template>
  <div>

    <div class="vx-row mt-4">
      <div class="vx-col w-1/2">
        <select-warehouse :isMultiple="false" @data="setWarehouse"></select-warehouse>
        <select-driver @data="setDriver" ref="select_driver"></select-driver>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full flex items-center">
            <span>Date</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <vs-input v-model="date" type="date" class="w-full mb-6" />
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row mb-6" style="width:50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-button color="primary" @click="handleFilter()">Filter</vs-button>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-base">
        <data-table :date="this.date" :territoryID="this.warehouse_id" :driverIds="this.driverIds"
          :baseUrl="this.baseUrl" :draw="draw" :status="this.status" :is-get-data="this.isGetData"></data-table>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from "./_components/Table.vue";
import SelectWarehouse from "./_components/select-warehouse.vue";
import SelectDriver from "./_components/select-driver.vue";
import InputDate from "./_components/input-date.vue";
export default {
  components: {
    DataTable,
    SelectWarehouse,
    SelectDriver,
    InputDate,
  },
  data() {
    return {
      baseUrl: "/api/sfa/v1/daily-closing/driver",
      date: this.getToday(),
      driver: {
        id: null,
        name: null,
      },
      driverIds: '',
      warehouse_id: null,
      warehouses: [],
      personal_id: null,
      draw: 0,
      status: 1,
      isGetData: false,
    };
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    setDriver(id, name) {
      this.driver.id = id;
      this.driver.name = name;
    },
    setWarehouse(selecteds) {
      this.warehouses = selecteds.map((item) => {
        this.warehouse_id = item.id;
        return {
          id: item.id,
          code: item.code,
        };
      });
    },
    getToday() {
      const today = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      return `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    },
    handleFilter() {
      if (this.date == null) {
        this.$vs.notify({
          title: "Error",
          text: "Please select date",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      let driver_ids = [];
      driver_ids = this.$refs.select_driver.selected;

      if (!this.$refs.select_driver.selected) {
        driver_ids = this.$refs.select_driver.options;
      }

      if (driver_ids.length > 0) {
        driver_ids = driver_ids.map((item) => item.id);
      }

      this.driverIds = driver_ids.join(",")

      this.draw++;
      this.isGetData = true
    },
  },
  mounted() {
    // this.territoryID = this.$userLogin.territory_id
    // this.getTerritory();
  },
  watch: {
    warehouses: function (val) {
      if (val.length == 0) {
        return;
      }
      let ids = val.map((item) => item.id);
      let params = {
        warehouse_id: ids.join(","),
        length: 0,
      };
      this.$refs.select_driver.reset();
      this.$refs.select_driver.getDataByTerritory(params);

    },
  },
};
</script>

<style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}

.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.core-enter,
.core-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateX(10px);
  opacity: 0;
}

.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}

.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
</style>
